import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

export function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
      setIsVisible(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <div className="glass-panel p-4 rounded-lg shadow-lg flex items-center space-x-4">
        <p className="text-sm text-slate-300">Install Ask Rumi for offline access</p>
        <button
          onClick={handleInstall}
          className="btn-primary text-sm flex items-center space-x-2 py-2"
        >
          <Download className="w-4 h-4" />
          <span>Install</span>
        </button>
      </div>
    </div>
  );
}